import Icon from "~/components/ui/Icon"
import { ProductListingPage } from "@decocms/apps-commerce/types"
import { useSignal } from "~/sdk/signal"
import { lazy, Suspense } from "react"

const Filters = lazy(() => import('~/components/search/Filters'))

export interface Props {
    filters: ProductListingPage['filters']
    categoryName: string
    isSearchPage: boolean
    url: string
    isMobile?: boolean
    isPerformanceTestPage: boolean
    paginateFilterOnMobile?: boolean
    brandPage?: boolean
}

export default function FiltersDrawer(
    { filters, categoryName, isSearchPage, url, isMobile, isPerformanceTestPage, paginateFilterOnMobile, brandPage }: Props,
) {
    const loading = useSignal(true)

    return (
        <div className='drawer w-auto'>
            <input
                id='filters-drawer'
                className='drawer-toggle'
                type='checkbox'
                hidden
                aria-hidden
                onChange={() => {
                    loading.value = false
                }}
            />

            <div className='drawer-content'>
                <label
                    className='bg-salmon text-white cursor-pointer w-full px-2 h-full sm:px-4 flex justify-between items-center text-sm'
                    htmlFor='filters-drawer'
                >
                    <span>
                        Filtros de <span className='font-black'>Pesquisa</span>
                    </span>

                    <Icon id='FilledChevronDown' size={7} />
                </label>
            </div>

            <div className='drawer-side z-50'>
                <label className='drawer-overlay' htmlFor='filters-drawer' />

                <div className='w-[80%] h-full bg-white overflow-y-auto scroll scroll-salmon scroll-lg px-5 overscroll-contain'>
                    <div className='py-3 border-b border-[#ededed] flex justify-between items-center'>
                        <h2 className='text-2xl font-bold text-red-wine'>
                            Filtre sua Busca
                        </h2>

                        <label
                            className='h-12 w-12 text-black flex justify-center items-center'
                            htmlFor='filters-drawer'
                        >
                            <Icon id='XMark' size={18} strokeWidth={4} />
                        </label>
                    </div>

                    <Suspense
                        fallback={
                            <div className='py-20 flex justify-center items-center'>
                                <div className='loading' />
                            </div>
                        }
                    >
                        {!loading.value && (
                            <Filters
                                filters={filters}
                                categoryName={categoryName}
                                isSearchPage={isSearchPage}
                                url={url}
                                isMobile={isMobile}
                                isPerformanceTestPage={isPerformanceTestPage}
                                paginateFilterOnMobile={paginateFilterOnMobile}
                                brandPage={brandPage}
                            />
                        )}
                    </Suspense>
                </div>
            </div>
        </div>
    )
}
